import { createServerOnlyFn } from "@tanstack/react-start";
import { createApplicationIntake } from "./create-internal.server";

export const applicationIntakesCreateApiRoute = {
    server: {
        handlers: {
            POST: createServerOnlyFn(({ request }: { request: Request }) =>
                createApplicationIntake(request),
            ),
        },
    },
};
